import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { AuthService } from '../common/services/auth.service';

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const expectedRoles: string[] = route.data['expectedRoles'];
    const roles: string[] = this.authService.getRoles() || [];

    const hasRole = expectedRoles.some(r => roles.includes(r));
    if (!hasRole) {
      this.router.navigate(['/']);
      return false;
    }
    return true;
  }
}